import { render, staticRenderFns } from "./TicketManagement.vue?vue&type=template&id=6a1b91ec&scoped=true"
import script from "./TicketManagement.vue?vue&type=script&lang=js"
export * from "./TicketManagement.vue?vue&type=script&lang=js"
import style0 from "./TicketManagement.vue?vue&type=style&index=0&id=6a1b91ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1b91ec",
  null
  
)

export default component.exports